import { useEffect, lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { ThemeProvider } from "@/context/ThemeContext";
import Layout from "@/components/layout/Layout";
import Home from "@/pages/Home";
import NotFound from "@/pages/NotFound";

// Route-level code splitting keeps the initial JS bundle small (better LCP / INP)
const Services = lazy(() => import("@/pages/Services"));
const ServiceDetail = lazy(() => import("@/pages/ServiceDetail"));
const Portfolio = lazy(() => import("@/pages/Portfolio"));
const About = lazy(() => import("@/pages/About"));
const Blog = lazy(() => import("@/pages/Blog"));
const BlogPost = lazy(() => import("@/pages/BlogPost"));
const Careers = lazy(() => import("@/pages/Careers"));
const Contact = lazy(() => import("@/pages/Contact"));
const Admin = lazy(() => import("@/pages/Admin"));
const Legal = lazy(() => import("@/pages/Legal"));

const page = (el) => <Suspense fallback={<div className="min-h-[70vh]" />}>{el}</Suspense>;

function App() {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <ThemeProvider>
      <BrowserRouter>
        <Toaster position="top-center" richColors />
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={page(<Services />)} />
            <Route path="/services/:slug" element={page(<ServiceDetail />)} />
            <Route path="/portfolio" element={page(<Portfolio />)} />
            <Route path="/about" element={page(<About />)} />
            <Route path="/blog" element={page(<Blog />)} />
            <Route path="/blog/:slug" element={page(<BlogPost />)} />
            <Route path="/careers" element={page(<Careers />)} />
            <Route path="/contact" element={page(<Contact />)} />
            <Route path="/privacy-policy" element={page(<Legal doc="privacy" />)} />
            <Route path="/terms" element={page(<Legal doc="terms" />)} />
            <Route path="/admin" element={page(<Admin />)} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
